<template>
  <NuxtLoadingIndicator color="#db2777" :height="5" :duration="4000" />
   <div class="h-screen" v-if="!manutencao">
    <NuxtLayout>
      <NuxtPage />
      <AppTabMenu />
    </NuxtLayout>
  </div>
<div v-else>
  <ErrorAllpage  texto1="Manutenção" texto2="Estamos fazendo melhorias no momento. Por favor, volte mais tarde."  />
<SeoMetaTags titulo='Manutenção' />
</div>

</template>
<script setup>
  const runtimeConfig = useRuntimeConfig();
  const url = useRequestURL();
  const manutencao = ref(false);
  
  // Verifica se a flag está ativa e se o domínio é o oficial
  const isTargetDomain = url.host.includes('ticketsmile.com.br');
  const isManutencaoActive = (runtimeConfig.public.NUXT_MANUTENCAO === "true");

  manutencao.value = isManutencaoActive && isTargetDomain;


</script>
<style>
.cky-btn-revisit-wrapper{
  background-color: #d52b74!important;
}

@media screen and (max-width: 915px) {
  .cky-btn-revisit-wrapper{
  bottom: 85px!important;
}
}



@media screen and (max-width: 1024px) {
  .crisp-client .cc-1brb6 .cc-1yy0g .cc-1m2mf {
  margin-bottom: 85px !important;
}

.crisp-client .cc-1brb6 .cc-1yy0g .cc-1m2mf .cc-6lwfw .cc-1pzwe {
  margin-bottom: 85px !important;
}
}
</style>